import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'RemoveWhitespace'
})
export class RemoveWhitespace implements PipeTransform {

  transform(value: string, args?: any): string {
    return value.replace(/ /g, '');
  }
}

@Pipe({
  standalone: true,
  name: 'TransformFileAttachment'
})
export class TransformFileAttachment implements PipeTransform {

  transform(value: string, args?: any): string {
    return value.slice(0, -15);
  }
}

@Pipe({
  standalone: true,
  name: 'TransformRunFrequency'
})
export class TransformRunFrequency implements PipeTransform {

  transform(value: string, args?: any): string {
    if (value === '1 hour')
      return 'HOUR';
    if (value === '1 day')
      return 'DAY';
    return value.toUpperCase();
  }
}

@Pipe({
  standalone: true,
  name: 'compactNumberValues'
})
export class CompactNumberValuesPipe implements PipeTransform {
  private static readonly THRESHOLDS = [
    { value: 1e15, symbol: 'Q' },
    { value: 1e12, symbol: 'T' },
    { value: 1e9,  symbol: 'B' },
    { value: 1e6,  symbol: 'M' },
    { value: 1e3,  symbol: 'K' },
    { value: 1,    symbol: ''  }
  ];

  transform(value: number | string | null | undefined): string {
    if (value == null) {
      return '';
    }
    const raw = value.toString().trim();
    // Number('') and Number(' ') are both 0, which would render a real-looking '0'.
    if (!raw) {
      return '';
    }
    const num = Number(raw.replace(/,/g, ''));
    if (isNaN(num)) {
      return value.toString();
    }
    if (num === 0) {
      return '0';
    }

    const thresholds = CompactNumberValuesPipe.THRESHOLDS;
    let index = thresholds.findIndex(t => Math.abs(num) >= t.value);
    if (index === -1) {
      return num.toString();
    }
    let formatted = CompactNumberValuesPipe.round(num / thresholds[index].value);
    // Rounding can carry the value onto the next threshold, e.g. 999,999 would
    // otherwise render as '1000.0K' rather than '1M'.
    if (Math.abs(Number(formatted)) >= 1000 && index > 0) {
      index -= 1;
      formatted = CompactNumberValuesPipe.round(num / thresholds[index].value);
    }
    return `${formatted}${thresholds[index].symbol}`;
  }

  /** One decimal place, dropping a redundant trailing '.0'. */
  private static round(scaled: number): string {
    const formatted = scaled.toFixed(1);
    return formatted.endsWith('.0') ? formatted.slice(0, -2) : formatted;
  }
}
